import React from "react";
import styles from "./ArchiveWrapper.module.scss";
import LoadingSpinner from "../LoadingSpinner";
import NoResults from "../NoResults";
import { genDisplayCount } from "../../utils/GeneralUtils";
import DBListPager from "../db-list/DBListPager";
import ArchiveHeader from "./ArchiveHeader";
import ArchiveResultCounter from "./ArchiveResultCounter";
import { PageTypes } from "../../utils/PageTypes";
import EventEmptyState from "../../features/event-db/EventEmptyState";

type Props = {
  title: string;
  hasResults: boolean;
  isLoading: boolean;
  currentPage: number;
  perView: number;
  totalEntries: number;
  totalPages: number;
  handlePerView: (value: number) => void;
  children: React.ReactNode;
  searchComponent?: React.ReactNode;
  type?: PageTypes;
};
const ArchiveWrapper: React.FC<Props> = ({
  title,
  hasResults,
  isLoading,
  currentPage,
  perView,
  totalEntries,
  totalPages,
  handlePerView,
  children,
  searchComponent,
  type,
}) => {
  const switchEmptyComponent = (type?: PageTypes) => {
    switch (type) {
      case PageTypes.Event:
        return <EventEmptyState />;
      default:
        return <NoResults />;
    }
  };

  return (
    <div className={styles["archive"]}>
      <section className={styles["archive__list-container"]}>
        <ArchiveHeader
          title={title}
          perView={perView}
          handlePerView={handlePerView}
          searchComponent={searchComponent}
        />
        {isLoading ? (
          <LoadingSpinner space={1} />
        ) : !hasResults ? (
          switchEmptyComponent(type)
        ) : (
          <>
            <div
              className={
                type
                  ? `${styles["archive__list"]} ${styles[type]}`
                  : styles["archive__list"]
              }
            >
              {children}
            </div>
            <ArchiveResultCounter
              current={genDisplayCount(
                currentPage,
                totalPages,
                perView,
                totalEntries
              )}
              total={totalEntries}
            />
            <DBListPager
              totalPage={totalPages}
              currentPage={currentPage}
              shouldScrollToTop={true}
            />
          </>
        )}
      </section>
    </div>
  );
};

export default ArchiveWrapper;
